import { render, staticRenderFns } from "./uploadLink.vue?vue&type=template&id=b0d807f0&scoped=true&"
import script from "./uploadLink.vue?vue&type=script&lang=js&"
export * from "./uploadLink.vue?vue&type=script&lang=js&"
import style0 from "./uploadLink.vue?vue&type=style&index=0&id=b0d807f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d807f0",
  null
  
)

export default component.exports